import { CarouselModal } from '@libs/components'
import { padding } from '@libs/theme/mixins'
import styled from 'styled-components'

const Modal = styled(CarouselModal)`
	.ant-modal-footer {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: ${padding('xxs', 'sm')} !important;

		> button:last-child {
			min-width: auto;
		}
	}
`

export default {
	Modal,
}
